export class UserPerfil {

    apellido: string;
    ci: string;
    ciudad: string;
    email: string;
    nombre: string;
    perfil: string;
    razon_social: string;
    ruc: string;
    usuario: number;

    constructor(data: any) {
        let usr = data['usuario'];
        this.apellido = usr['cliente']['ape_cliente'];
        this.ci = usr['cliente']['nro_documento'];
        this.ciudad = usr['cliente']['ciudad'];
        this.email = usr['cliente']['email_cliente'];        
        this.nombre = usr['cliente']['nom_cliente'];
        this.perfil = usr['perfil_usuario']['des_perfil'];
        this.razon_social = usr['cliente']['razon_social'];
        this.ruc = usr['cliente']['nro_ruc'];
        this.usuario = usr['usuario'];
    }

}

/*
usuario: {usuario: "rmegale", fecha_alta: "2012-03-15", fecha_baja: null, cod_perfil: 2, cod_empresa: 1,…}
cliente: {cod_empresa: 1, cod_cliente: 906, nom_cliente: "RICARDO", ape_cliente: "MEGALE", tipo: "F",…}
ape_cliente: "MEGALE"
cel_cliente_part: "0981473578"
ciudad: "ASUNCION"
cod_cliente: 906
cod_empresa: 1
contacto: "N/A"
datos_notificados: false
dir_cliente_lab: "AV. VENEZUELA NA  1547"
dir_cliente_part: "AV. VENEZUELA NA  1542"
email_cliente: "rmegale@gtp.com.py"
fax_cliente_lab: ""
fecha_alta: "2016-10-25"
fecha_baja: "1970-01-01"
fecha_hora_mod: "2017-12-06T18:39:28.404Z"
fecha_nacimiento: "1970-01-01"
logo_cliente: ""
nom_cliente: "RICARDO"
nro_documento: "2.220.090"
nro_ruc: "2220090-8"
path_contrato: ""
path_logo_cliente: ""
razon_social: "RICARDO FELICIANGELI"
rubro_empresarial_id: 10
tel_cliente_lab: ""
tel_cliente_part: "021286115"
tipo: "F"
usuario_mod: "rmegale"
cod_cliente: 906
cod_empresa: 1
cod_perfil: 2
fecha_alta: "2012-03-15"
fecha_baja: null
gruposCliente: []
perfil_usuario: {cod_perfil: 2, des_perfil: "ADMINISTRADOR"}
cod_perfil: 2
des_perfil: "ADMINISTRADOR"
tipo_mapa: null
usuario: "rmegale"
*/